import { render, staticRenderFns } from "./bkxx2.vue?vue&type=template&id=70fe9f50&scoped=true&"
import script from "./bkxx2.vue?vue&type=script&lang=js&"
export * from "./bkxx2.vue?vue&type=script&lang=js&"
import style0 from "./bkxx2.vue?vue&type=style&index=0&id=70fe9f50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fe9f50",
  null
  
)

export default component.exports